import { render } from "./FinishAndTest.vue?vue&type=template&id=209b3f2e"
import script from "./FinishAndTest.vue?vue&type=script&lang=js"
export * from "./FinishAndTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__